import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "listings",
    defaultRoutePath: "/opportunities/listing",
    menuItemScope: "operations",
    menuItemName: "listing",

    routes: [
        {
            path: "/opportunities/listing",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
